var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "accordion-wrapper" }, [
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "column" }, [
        _vm.isHeadline
          ? _c(
              "div",
              { staticClass: "accordion__headline" },
              [
                _c("v-typo", {
                  attrs: { variant: "h2" },
                  domProps: { innerHTML: _vm._s(_vm.data.headline) }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "accordion" },
          _vm._l(_vm.data.items, function(accordion, accordionIndex) {
            return _c("v-accordion-item", {
              key: "accordion-" + accordion.index + "-" + accordionIndex,
              ref: "items",
              refInFor: true,
              attrs: {
                name: _vm.name,
                "can-toggle": _vm.toggle,
                animatedCards: _vm.animatedCards ? _vm.animatedCards : null,
                cards: _vm.data.items[accordionIndex].cards,
                content: accordion.content,
                index: accordion.index,
                title: accordion.title
              }
            })
          }),
          1
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }